import { render, staticRenderFns } from "./VerdictEntityDetails.vue?vue&type=template&id=4a49c8b6&scoped=true"
import script from "./VerdictEntityDetails.vue?vue&type=script&lang=js"
export * from "./VerdictEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./VerdictEntityDetails.vue?vue&type=style&index=0&id=4a49c8b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a49c8b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a49c8b6')) {
      api.createRecord('4a49c8b6', component.options)
    } else {
      api.reload('4a49c8b6', component.options)
    }
    module.hot.accept("./VerdictEntityDetails.vue?vue&type=template&id=4a49c8b6&scoped=true", function () {
      api.rerender('4a49c8b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VerdictEntityDetails.vue"
export default component.exports